import {Injectable} from '@angular/core';
import {ParentService} from "./parent.service";

declare global {
    interface Window {
        dataLayer: any[];
    }
}

@Injectable({
    providedIn: 'root'
})
export class AnalyticsService {

    constructor() {
    }

    login() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'login'
        });
    }

    registration(studentId: string) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'sign_up',
            'id_user': studentId
        })
    }
}
